import { createContext } from 'react';
import { defaultState } from './reducer';

const PrivateLayoutContext = createContext({
  ...defaultState,
  dispatch: (action?: any) => {},
});

export default PrivateLayoutContext;
